/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreatePackageForm = {
  /**
   * The description of the package. Limited markdown syntax is supported.
   */
  description?: string | undefined;
  /**
   * The asset ID of the image to show for this package
   */
  imageAssetId?: string | undefined;
  /**
   * The keywords of the package
   */
  keywords?: Array<string> | undefined;
  /**
   * The name of the package
   */
  name: string;
  /**
   * The summary of the package
   */
  summary: string;
  /**
   * The title of the package
   */
  title: string;
  /**
   * External URL for the package owner
   */
  url?: string | undefined;
};

/** @internal */
export type CreatePackageForm$Outbound = {
  description?: string | undefined;
  image_asset_id?: string | undefined;
  keywords?: Array<string> | undefined;
  name: string;
  summary: string;
  title: string;
  url?: string | undefined;
};

/** @internal */
export const CreatePackageForm$outboundSchema: z.ZodMiniType<
  CreatePackageForm$Outbound,
  CreatePackageForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    imageAssetId: z.optional(z.string()),
    keywords: z.optional(z.array(z.string())),
    name: z.string(),
    summary: z.string(),
    title: z.string(),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      imageAssetId: "image_asset_id",
    });
  }),
);

export function createPackageFormToJSON(
  createPackageForm: CreatePackageForm,
): string {
  return JSON.stringify(
    CreatePackageForm$outboundSchema.parse(createPackageForm),
  );
}
